<script lang="ts">
  import { configStore } from '@src/stores/config'

  import { get } from 'svelte/store'
  import { generate } from 'lean-qr'
  import { analytics } from '@lib/mixpanel/mixpanel'
  import { toSvgSource } from 'lean-qr/extras/svg'
  import { clientPublicStore, fn, userStore } from '@packages/stores'

  import { PassportLocalStorage } from '@packages/utils/enums'

  import { ScanTypes } from '@packages/utils/enums'
  import { PassportId } from '@packages/ui'
  import { getAddress } from '@src/passport/blockchain'
  import socketFn from '@lib/ws/socket-io'

  const { toastAlert } = get(fn)

  let QrCodeSvg: string | null = null
  let message: string = 'Signing your ID...'

  $: {
    if ($configStore.suiNetwork) generateCode()
  }

  const generateCode = async () => {
    try {
      const date = new Date().toISOString()
      analytics.track('cp_passport_id', { date, address: await getAddress() })
      const qrData = JSON.stringify({
        scanType: ScanTypes.PASSPORT_ID,
        date,
        sub: $userStore?.sub,
      })
      await socketFn.connectSocketForSignatures($configStore.credenza.generalWssUrl)
      const code = generate(qrData)
      QrCodeSvg = toSvgSource(code, { width: 300, height: 300 })

      try {
        localStorage.setItem(PassportLocalStorage.QR_CODE, qrData)
      } catch (err) {
        toastAlert('QR code caching failed. Please check your browser settings and enable local storage.')
      }
    } catch (err) {
      console.log(err)
      message = 'QR code generation failed'
    }
  }

  // const getPass = async () => {
  //   const result = await fetch(`https://evm.credenza3.com/wallet_pass/${$configStore.chainId}`, {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${get(accessTokenStore)}`,
  //     },
  //   })
  //   if (!result.ok) return toastAlert('Failed to get ApplePass')
  //   const json = await result.json()
  //   const link = document.createElement('a')
  //   link.href = json.download_url
  //   link.target = '_blank'
  //   link.click()
  // }
</script>

<PassportId
  options={{
    title: 'Show ID',
    description: 'This information is used to verify your personal identity.',
    QrCodeSvg,
    errorMessage: message,
    onClick: generateCode,
    userInfoOptions: {
      storedValueAlias:$clientPublicStore.ui_settings.stored_value_alias,
      userData: $userStore,
      userAddress: getAddress(),
    },
    // getPass,
  }}
/>
